<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TaxonHeader',
  computed: {
    ...mapGetters({
      selectedTaxon: 'search/selectedTaxon',
    }),
    name() {
      return this.selectedTaxon.pretty_name.split('->').join('>').split('-').join(' ');
    },
  },
};
</script>

<template>
  <div class="mt-8 md:mt-0 pl-2 md:pl-0 font-semibold
        text-base text-blue-diagomics-dark" v-if="selectedTaxon">
    {{ name }}
  </div>
</template>
